var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnisizeEnd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4266_33533",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 8,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.028 6.37641C10.7416 7.79603 8.77884 10.8603 7.72315 12.3208C6.65776 10.8477 4.60507 7.52908 4.42289 6.37641C4.10579 4.37022 5.45393 2.67944 7.74165 2.6792C10.0294 2.67896 11.4142 4.46185 11.028 6.37641Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.605
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4266_33533)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3859 1.39453H3.08008V13.2854H12.3859V1.39453ZM7.73506 6.77273C8.34395 6.77273 8.83755 6.27912 8.83755 5.67023C8.83755 5.06134 8.34395 4.56773 7.73506 4.56773C7.12617 4.56773 6.63256 5.06134 6.63256 5.67023C6.63256 6.27912 7.12617 6.77273 7.73506 6.77273Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnisizeEnd);
export default __webpack_public_path__ + "static/media/unisize_end.ac6372e797faee66a3d7d90b86edb9f0.svg";
export { ForwardRef as ReactComponent };